// i18n/config.ts — i18next initialization

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en'],
    ns: [
      'common',
      'tree',
      'profile',
      'messaging',
      'merge',
      'matrimonial',
      'onboarding',
      'privacy',
      'home',
    ],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'foi-locale',
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
